import { createSelector } from 'reselect';
import { getIsMESEnabled } from './getIsMESEnabled';
import { getMachineSettings } from './getMachineSettings';

/** Returns true when MES is enabled and machine has ERP job dispatch enabled. */
export const getIsMESErpJobDispatchEnabled = createSelector(
  [getIsMESEnabled, getMachineSettings],
  (mesEnabled, machineSettings) => {
    return mesEnabled && machineSettings?.erpJobDispatchEnabled === true;
  }
);
